import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useMemo, useRef, useState } from 'react';
import { ymPushChatWord, ymPushClickChatInput, ymPushSendAttach, ymPushSendMessage, ymPushStartTyping } from "../../../../../shared/analytics";
import { getImageSize, useSessionState } from "../../../../../shared/lib";
import { FSMStages, generateFileThunk, useAppDispatch, useAppSelector, useCommunicationContext, useFSM, useScrollContext } from "../../../../../shared/model";
import { AttachLabel } from "../../../../../shared/config";
import { addMessage, selectImgTypeUploadOpen, selectIsLoading, selectReplyMessage, setStoreImgPreview, updateMessageStatus } from "../../../../../entities/message/model";
import { useNotificationContext } from "../../../../../entities/notification/model";
import { selectChatCofig } from "../../../../../entities/settings/model";
import { CHARS_LIMIT_NOTIFICATION_KEY, SYSTEM_PROBLEM_NOTIFICATION_KEY } from "../../../../notifications/lib";
import { addQuickReplies, addStoreImageUrlGroup, selectImageUrlGroup } from "../../../../../entities/content/model";
import { MessageStatus, MessageType, createHistoryMessage } from "../../../../../shared/api";
import { prepareImage } from "../../utils";
import { ImgPreviewType } from "../../../../../shared/types/settings";
import { useBlockMobileNavigation } from "../useBlockMobileNavigation";
export var useForm = function useForm() {
  var _message$trim;
  var dispatch = useAppDispatch();
  var _useSessionState = useSessionState('chatCurrentMessage', {
      // Необходимо так как хук по умолчанию конвертирует данные в конкретный тип (если текст число то результат хука выйдет по типам тоже число)
      storeToState: function storeToState(val) {
        return val;
      },
      stateToStore: function stateToStore(val) {
        return val || '';
      }
    }),
    _useSessionState2 = _slicedToArray(_useSessionState, 2),
    message = _useSessionState2[0],
    setMessage = _useSessionState2[1];
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var isLoading = useAppSelector(selectIsLoading);
  var replyMessage = useAppSelector(selectReplyMessage);
  var _useAppSelector = useAppSelector(selectChatCofig),
    charsLimit = _useAppSelector.charsLimit,
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var isOpenPreview = useAppSelector(selectImgTypeUploadOpen);
  var imageUrlGroup = useAppSelector(selectImageUrlGroup);
  var _useCommunicationCont = useCommunicationContext(),
    sendMessage = _useCommunicationCont.sendMessage,
    sendImgMessage = _useCommunicationCont.sendImgMessage;
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom;
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var isEnterDisabled = stage === FSMStages.BLOCKED;
  var isSubmitDisabled = !isOpenPreview && (!(message && (message === null || message === void 0 || (_message$trim = message.trim) === null || _message$trim === void 0 ? void 0 : _message$trim.call(message)) !== '') || isLoading || isEnterDisabled);
  var _useNotificationConte = useNotificationContext(),
    addNotification = _useNotificationConte.addNotification,
    removeNotification = _useNotificationConte.removeNotification,
    getNotificationQueue = _useNotificationConte.getNotificationQueue;
  var _useBlockMobileNaviga = useBlockMobileNavigation(),
    inputRef = _useBlockMobileNaviga.inputRef,
    onFocus = _useBlockMobileNaviga.onFocus,
    onBlur = _useBlockMobileNaviga.onBlur;
  var imageRef = useRef(null);
  var handleImgLoad = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _imageRef$current;
      var fileList, fileData, handleOpenModalPreview, compressed, imgUrl, imgPreviewUrl, imageSettings;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Загруженное изображение
            fileList = (_imageRef$current = imageRef.current) === null || _imageRef$current === void 0 ? void 0 : _imageRef$current.files;
            if (!fileList) {
              _context.next = 17;
              break;
            }
            fileData = fileList[0];
            handleOpenModalPreview = function handleOpenModalPreview() {
              return dispatch(setStoreImgPreview({
                isImgPreviewOpen: true,
                type: ImgPreviewType.upload
              }));
            };
            _context.next = 6;
            return prepareImage(fileData, handleOpenModalPreview);
          case 6:
            compressed = _context.sent;
            if (compressed) {
              _context.next = 10;
              break;
            }
            addNotification({
              key: 'bigSize',
              label: 'большой размер фото',
              subTitle: 'попробуйте загрузить другое',
              view: 'error'
            });
            return _context.abrupt("return");
          case 10:
            // Установка URL загруженного изображения
            imgUrl = URL.createObjectURL(compressed.image);
            imgPreviewUrl = URL.createObjectURL(compressed.imagePreview);
            _context.next = 14;
            return getImageSize(fileData);
          case 14:
            imageSettings = _context.sent;
            dispatch(addStoreImageUrlGroup({
              fileUrl: imgUrl,
              filePreviewUrl: imgPreviewUrl,
              imageSettings: imageSettings
            }));
            setFiles({
              image: compressed.image,
              imagePreview: compressed.imagePreview,
              imageSettings: imageSettings
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleImgLoad() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var _inputRef$current;
      var formData, previewFormData, historyImageMessage, historyTextMessage;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();

            // Сохраняем клавиатуру открытой после отправки сообщения
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
            if (!(files && imageUrlGroup)) {
              _context2.next = 18;
              break;
            }
            formData = new FormData();
            previewFormData = new FormData();
            formData.append('file', files.image);
            previewFormData.append('file', files.imagePreview);
            // Добавляем изображение в историю со статусом MessageStatus.sent
            historyImageMessage = createHistoryMessage('', {
              status: MessageStatus.sent,
              messageType: MessageType.Img
            }, {
              imageUrlGroup: imageUrlGroup
            });
            dispatch(addQuickReplies([]));
            dispatch(addMessage(historyImageMessage));
            // Добавляем подпись в историю со статусом MessageStatus.sent
            if (message) {
              historyTextMessage = createHistoryMessage(message, {
                status: MessageStatus.sent,
                messageType: MessageType.Text
              });
              dispatch(addMessage(historyTextMessage));
            }
            dispatch(setStoreImgPreview({
              isImgPreviewOpen: false,
              type: ImgPreviewType.upload
            }));

            // Обнуление url изображения в сторе, для предотвращения повторной отправки
            dispatch(addStoreImageUrlGroup(null));
            setFiles(null);
            setMessage('');

            // Скролл вниз при добавлении изображения в историю
            scrollToBottom(0);

            // Отправляем на бэк изображение и превью, получаем в ответе id
            _context2.next = 18;
            return Promise.all([dispatch(generateFileThunk(formData)), dispatch(generateFileThunk(previewFormData))]).then(function (response) {
              var _historyTextMessage;
              // Отправка id изображения и превью в WS
              // Обновления MessageStatus изображения в истории после успешного получения imageIdGroup
              // Отправка подписи в историю и обновление MessageStatus подписи после успешного получения imageIdGroup
              sendImgMessage({
                imageId: response[0].payload.id,
                imagePreviewId: response[1].payload.id,
                imageSettings: files.imageSettings
              }, historyImageMessage.messageId, message, (_historyTextMessage = historyTextMessage) === null || _historyTextMessage === void 0 ? void 0 : _historyTextMessage.messageId);
              ymPushSendAttach(AttachLabel.IMAGE, zoneType);
            }).catch(function () {
              dispatch(updateMessageStatus({
                id: historyImageMessage.messageId,
                status: MessageStatus.failed
              }));
              if (message) {
                dispatch(updateMessageStatus({
                  id: historyTextMessage.messageId,
                  status: MessageStatus.failed
                }));
              }
            });
          case 18:
            if (message && !imageUrlGroup) {
              sendMessage(message, replyMessage === null || replyMessage === void 0 ? void 0 : replyMessage.messageId, function () {
                return setMessage('');
              });
              ymPushSendMessage();
            }
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleMessageChange = function handleMessageChange(value) {
    setMessage(value.slice(0, charsLimit));
    ymPushChatWord(zoneType);
    var updateNotification = function updateNotification() {
      if (value.length <= charsLimit) {
        removeNotification(CHARS_LIMIT_NOTIFICATION_KEY);
      } else {
        addNotification({
          key: CHARS_LIMIT_NOTIFICATION_KEY,
          label: "\u0412\u0430\u0448 \u0442\u0435\u043A\u0441\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C ".concat(charsLimit, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")
        });
      }
    };
    if (getNotificationQueue().find(function (el) {
      return el.key === SYSTEM_PROBLEM_NOTIFICATION_KEY;
    })) {
      setTimeout(function () {
        removeNotification(SYSTEM_PROBLEM_NOTIFICATION_KEY);
        updateNotification();
      }, 3000);
    } else {
      updateNotification();
    }
  };
  var handleKeyDown = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(e.key === 'Enter' && !e.shiftKey && !isSubmitDisabled)) {
              _context3.next = 3;
              break;
            }
            _context3.next = 3;
            return handleSubmitForm(e);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleKeyDown(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleFocus = function handleFocus() {
    ymPushStartTyping();
    ymPushClickChatInput(zoneType);
    onFocus();
  };
  var handleBlur = function handleBlur() {
    onBlur();
  };

  /* Очищаем поле ввода когда находимся в блоке */
  useEffect(function () {
    if (isEnterDisabled) {
      setMessage('');
    }
  }, [isEnterDisabled]);
  var params = useMemo(function () {
    return {
      attachmentProps: {
        imageRef: imageRef,
        onImageChange: handleImgLoad,
        disabled: isEnterDisabled
      },
      inputProps: {
        maxRows: 5,
        minRows: 1,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleMessageChange,
        onKeyPress: handleKeyDown,
        ref: inputRef,
        value: message,
        disabled: isEnterDisabled
      },
      buttonProps: {
        disabled: isSubmitDisabled,
        onClick: handleSubmitForm,
        type: 'submit'
      }
    };
  }, [message, isLoading, replyMessage, isSubmitDisabled, isEnterDisabled, imageUrlGroup, files]);
  return {
    params: params,
    isSubmitDisabled: isSubmitDisabled,
    inputRef: inputRef
  };
};